import React from "react";

import DamageModals from "../modals";
import { FilterParamsList } from "components/service";

const DamageFilterBlock = ({ filter, sort }) => {
    return (
        <div className="filter-block damage-filter-block">
            <div className="modals grid-two-col">
                <DamageModals.Filter filter={filter} />
                <DamageModals.Sort sort={sort} />
            </div>
            <FilterParamsList
                filter={filter}
                fieldsArr={["where", "whereStand"]}
            />
        </div>
    );
};

export default DamageFilterBlock;
